import { useState, useEffect } from 'react';
const useAfterInitialRender = function (func) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const {
    0: initialRenderDone,
    1: setInitialRenderDone
  } = useState(false);
  useEffect(() => {
    if (initialRenderDone) {
      func();
    } else {
      setInitialRenderDone(true);
    }
  }, [initialRenderDone, ...deps]);
};
export default useAfterInitialRender;